<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.id" placeholder="Id" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.card_number" placeholder="Number" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.body" placeholder="Body" clearable style="width:280px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.sms_time" type="daterange" size="small" value-format="yyyy-MM-dd" align="right"
          unlink-panels start-placeholder="Start date(trans time)" end-placeholder="End date(trans time)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.save_time" type="daterange" size="small" value-format="yyyy-MM-dd" align="right"
          unlink-panels start-placeholder="Start date(save time)" end-placeholder="End date(save time)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button type="success" size="small" icon="el-icon-document" @click="exportExcel">Export</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 100%;">
      <el-table-column prop="id" label="Id" width="80" align="center">
      </el-table-column>
      <el-table-column prop="card_number" label="Number" width="120" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.card_number}}</div>
          <div>{{scope.row.sms_user_name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="country" label="Country" width="140">
      </el-table-column>
      <el-table-column prop="body" label="Body">
      </el-table-column>
      <el-table-column prop="address" label="Address" width="140">
      </el-table-column>
      <el-table-column prop="business_name" label="Business Name" width="140">
      </el-table-column>
      <el-table-column prop="add_time" label="Time" width="180">
        <template slot-scope="scope">
          <div><span style="color:#909399">sms：</span>{{scope.row.sms_time|timestampToTime}}</div>
          <div><span style="color:#909399">add：</span>{{scope.row.save_time|timestampToTime}}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Set Tag -->
    <el-dialog title="" :visible.sync="setTagVisible" @click='closeDialog("setTag")' width="50%">
      <el-descriptions title="Set Tag" :column="2" border style="padding-bottom:20px">
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Number">{{auxi_info.card_number}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="User">{{auxi_info.sms_user_name}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Address">{{auxi_info.address}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Save time">{{auxi_info.save_time|timestampToTime}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Body" span="2">
          {{auxi_info.body}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Select Tag" span="2">
          <el-radio-group v-model="auxi_info.flag">
            <el-radio v-for="item in flag_list" :key="item.v" :label="item.k">{{item.v}}
            </el-radio>
          </el-radio-group>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" :loading="loading" class="title" @click="setTagSubmit">Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    smsListAuxiNew,
    auxiTag,
    getCountryBusiness
  } from '../../api/apiFun'
  import {
    timestampToTime,
    exportUrl,
    cascaderChange,
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  let that = ""
  export default {
    data() {
      return {
        loading: false, //是显示加载
        setTagVisible: false, //控制Edit页面显示与隐藏
        examineVisible: false, //控制Edit页面显示与隐藏
        params: {
          page: 1,
          limit: 10,
          id: '',
          card_number: '',
          sms_time: '',
          save_time: '',
          body: '',
          country: '',
          business_name: '',
          type: 0,
          dev:''
        },
        trans_type_list: [{
            k: 1,
            v: 'Recharge'
          },
          {
            k: 2,
            v: 'Withdraw'
          }
        ],
        state_list: [{
            k: 0,
            v: '未匹配'
          },
          {
            k: 1,
            v: '已匹配'
          }
        ],
        listData: [], //User数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pickerOptions: {
          shortcuts: [{
            text: 'Today',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        auxi_info: {},
        flag_list: [{
            k: 1,
            v: 'Recharge'
          },
          {
            k: 2,
            v: 'Withdraw'
          },
          {
            k: 3,
            v: 'Recharge refund'
          },
          {
            k: 4,
            v: 'Withdraw refund'
          },
          {
            k: 5,
            v: 'Unknown'
          },
        ],
        country_business: []
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
      smsListAuxiNewstate: function (i) {
        var v = '';
        that.state_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      }
    },
    created() {
      that = this
      this.getdata(this.params)
      this.getCountryBusiness()
    },
    methods: {
      getCountryBusiness() {
        getCountryBusiness().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.country_business = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      cascaderChange(value) {
        var cascader = cascaderChange(value)
        this.params.country = cascader[0]
        this.params.business_name = cascader[1]
      },
      messageTag(row) {
        this.auxi_info = row
        this.setTagVisible = true
      },
      setTagSubmit() {
        if (!this.auxi_info.flag) {
          this.$message({
            type: 'error',
            message: 'Please select tag'
          })
          return
        }
        auxiTag({
          id: this.auxi_info.id,
          flag: this.auxi_info.flag,
        }).then(res => {
          this.loading = false
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: 'success'
            })
            this.getdata(this.params)
            this.setTagVisible = false
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed, please try again later!')
        })
      },
      closeDialog(type) {
        if (type == 'setTag') {
          this.setTagVisible = false
        }
      },
      exportExcel() {
        window.location.href = exportUrl('/admin/sms/export_auxi_sms', this.params);
      },
      // 获取Other message
      getdata(parameter) {
        if (parameter.sms_time == null) {
          parameter.sms_time = ''
        }
        if (parameter.save_time == null) {
          parameter.save_time = ''
        }
        this.loading = true
        smsListAuxiNew(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get other message, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
    }
  }

</script>

<style scoped>
  .el-image__error {
    font-size: 12px !important;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/sms/sms_list_garbage.vue